import { ValidationResult } from "lib/hooks/use-input";

export const isPositiveNumberValidator = (v: number): ValidationResult => {
  const value = parseInt(v.toString());
  if (value <= 0) {
    return {
      valid: false,
      message: "Please enter a number greater than 0",
    };
  }
  return { valid: true };
};
